import { configureStore, combineReducers } from "@reduxjs/toolkit";

import screenReducer from "./screen";
import scoreReducer from "./score";
import userReducer from "./user";
import authSlice from "./authSlice";

export const initialState = {
  screen: false,
};

const rootReducer = combineReducers({
  screen: screenReducer,
  score: scoreReducer,
  user: userReducer,
  auth:authSlice,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispath = typeof store.dispatch;
